
import { axiosInstanceWithoutErrorModal } from '../assets/utils/axiosInstance';

import { IRFIConversation } from '~/slices/rfiMessageSlice';

type FileItemType = {
  file_name: string,
  file_type: string,
  file_size: number,
  attachment_type: number
};


type FileUploadStartType = {
  id: number,
  url: string,
  fields: {
    'acl': string,
    'Content-Type': string,
    'key': string,
    'x-amz-algorithm': string,
    'x-amz-credential': string,
    'x-amz-date': string,
    'policy': string,
    'x-amz-signature': string,
    'x-amz-security-token': string,
  }
};

type FormFieldsType = {
  recipientName: string,
  recipientEmail: string,
  subject: string,
  dueDate: string | unknown,
  hasRequestToUploadFile: boolean,
  department: string,
};

type ReportType = {
  id: number,
  case_manager: string,
  department_name: string,
  status: number,
  due_date_formatted_date: string,
  rfi_conversation: IRFIConversation,
};

type RecipientDataType = {
  details: string,
  file_ids: Array<number>
};

type RecipientDetailsType = {
  id: number,
  recipient_email: string,
  recipient_name: string,
  department_name:string,
  has_request_to_upload_file: boolean,
  details: string,
  status: number,
  rfi_conversation: {
    id: string,
    recipient_full_name: string;
    recipient_email: string;
    conversation_subject: string;
    case_manager_id: number;
    recipient_id: number;
  },
};


type PatchRecipientDataType = {
  id: number,
  recipient_email: string,
  recipient_name: string,
  department_name: string,
  has_request_to_upload_file: boolean,
  details: string
};

const fetchReports = async (referenceId: string): Promise<{ data: Array<ReportType> }> => {

  const reportId = referenceId;
  try {
    const response = await axiosInstanceWithoutErrorModal().get<Array<ReportType>>(`/request-for-information/${reportId}`);
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};


const getPreDraftedEmail = async (referenceId: string) => {
  try {
    const response = await axiosInstanceWithoutErrorModal().get(`request-for-information/${referenceId}/pre-drafted-email`);
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};

const updateStatus = async (status: number, uniqueId: string, details: string) : Promise<{ data: PatchRecipientDataType }> => {
  try {
    const response = await axiosInstanceWithoutErrorModal().patch<PatchRecipientDataType>(`tenant/portal/request-for-information/${uniqueId}`, {
      status,
      file_ids: [],
      details,
    });
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};
const patchRecipientData = async (uniqueId: string, item: RecipientDataType): Promise<{ data: PatchRecipientDataType }> => {
  try {
    const response = await axiosInstanceWithoutErrorModal().patch<PatchRecipientDataType>(`tenant/portal/request-for-information/${uniqueId}`, {
      details: item.details,
      file_ids: item.file_ids,
      status: 3,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`, // Rfi recipient token
      },
    });
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};

const rfiConversationIsRead = async (conversationId: string): Promise<{ data: { message: string } }> => {
  return new Promise((resolve, reject) => {
    axiosInstanceWithoutErrorModal().patch<{ message: string }>(`/rfi-chat/${conversationId}/messages`)
      .then((response) => {
        resolve(response);
      }).catch(e => {
        reject(e);
      });
  });
};


const rfiConversationIsReadRecipient = async (conversationId: string): Promise<{ data: { message: string } }> => {
  return new Promise((resolve, reject) => {
    axiosInstanceWithoutErrorModal().patch<{ message: string }>(`/rfi-chat/${conversationId}/messages`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`, // Rfi recipient token
      },
    })
      .then((response) => {
        resolve(response);
      }).catch(e => {
        reject(e);
      });
  });
};

type GetCaseManagerDataFileType = {
  id: number,
  original_file_name: string,
  file_type: string,
  url: string
};

type GetCaseManagerDataType = {
  id: number,
  recipient_email: string,
  recipient_name: string,
  details: string,
  department_name: string,
  status: number,
  subject: string,
  due_date: string,
  due_date_formatted_date: string,
  has_request_to_upload_file: boolean,
  files: Array<GetCaseManagerDataFileType>
  closure_reason: string
};


const getCaseManagerData = async (recipientId: number): Promise<{ data: GetCaseManagerDataType }> => {

  try {
    const response = await axiosInstanceWithoutErrorModal().get<GetCaseManagerDataType>(`tenant/request-for-information/${recipientId}/details`);
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};

const getRecipientData = async (recipientId: string): Promise<{ data: RecipientDetailsType }> => {
  return new Promise((resolve, reject) => {
    axiosInstanceWithoutErrorModal().get<RecipientDetailsType>(`tenant/portal/request-for-information/${recipientId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`, // Rfi recipient token
      },
    })
      .then((response) => {
        resolve(response);
      }).catch(e => {
        reject(e);
      });
  });
};

const fileUploadFinish = async (slug: string, fileId: number): Promise<{ data: { message: string } }> => {
  try {
    const response = await axiosInstanceWithoutErrorModal().post<{ message: string }>(`/tenant/${slug}/report-request-for-information-file/upload/finish`, { file_id: fileId });
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};

const fileUploadStart = async (slug: string, item: FileItemType): Promise<{ data: FileUploadStartType }> => {
  
  try {
    const response = await axiosInstanceWithoutErrorModal().post<FileUploadStartType>(`/tenant/${slug}/report-request-for-information-file/upload/start`, item);
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }

};


const resendEmail = async (requestId: number): Promise<{ data: { message: string } }> => {
  try {
    const response = await axiosInstanceWithoutErrorModal().post<{ message: string }>(`/request-for-information/${requestId}/resend-email`);
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};

const sendEmail = async (requestId: number, content: string) => {

  try {
    const response = await axiosInstanceWithoutErrorModal().patch(`/request-for-information/${requestId}`, {
      email_body: content,
    });
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};
const createReportRequest = async (referenceId: string, item: FormFieldsType): Promise<{ data: { request_id: number, url: string } }> => {

  return new Promise((resolve, reject) => {

    let formatItem = JSON.parse(JSON.stringify(item));
    formatItem = {
      recipient_name: formatItem.recipientName,
      recipient_email: formatItem.recipientEmail,
      subject: formatItem.subject,
      due_date: formatItem.dueDate,
      has_request_to_upload_file: formatItem.hasRequestToUploadFile,
      department: formatItem.department,
    };

    axiosInstanceWithoutErrorModal().post<{ request_id: number, url: string }>(`/request-for-information/${referenceId}/create-request`, formatItem).then((response) => {
      resolve(response);
    }).catch(e => {
      reject(e);
    });

  });
};

const closeRfi = async (rfiID: number, closureReason: string) => {
  try {
    const response = await axiosInstanceWithoutErrorModal().patch(`tenant/request-for-information/${rfiID}/close-request`, {
      closure_reason: closureReason,
    });
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};




const requestInformationService = {
  fetchReports,
  createReportRequest,
  sendEmail,
  fileUploadStart,
  getPreDraftedEmail,
  resendEmail,
  fileUploadFinish,
  patchRecipientData,
  getRecipientData,
  getCaseManagerData,
  updateStatus,
  closeRfi,
  rfiConversationIsRead,
  rfiConversationIsReadRecipient,
};

export default requestInformationService;